<template>
  <el-container class="f-h center">
    <el-row type="flex" justify="center" align="middle" class="f-h f-w">
      <div v-if="!errMsg">
        <img v-if="theme && theme.loadingImgFile" :src="theme.loadingImgFile" />
        <h2>正在加载，请稍后…</h2>
      </div>
      <div v-else>
        <img v-if="theme && theme.errImgFile" :src="theme.errImgFile" />
        <h2 class="danger">{{ errMsg }}</h2>
      </div>
    </el-row>
  </el-container>
</template>

<script>
  import { mapGetters, api } from "sw-hic";
  import homeApi from "./dynamic/api";
  export default {
    data() {
      return {
        showEditor: false,
        entity: null,
        errMsg: null,
        readonly: false,
      };
    },
    computed: {
      ...mapGetters(["token", "theme", "user"]),
    },
    async mounted() {
      if ((this.$route.query.usr && this.$route.query.pwd && this.$route.query.tenant) || this.$route.query.token) {
        try {
          let res = null;
          if (this.$route.query.timeStamp) {
            this.$utils.log("MD5登录");
            res = await api.Server.md5Token(this.$route.query.usr, this.$route.query.pwd, this.$route.query.tenant, this.$route.query.timeStamp);
          } else if (this.$route.query.token) {
            this.$utils.log("TOKEN登录");
            res = { access_token: this.$route.query.token, refresh_token: this.$route.query.token };
          } else {
            this.$utils.log("密码登录");
            res = await api.Server.pwdToken(this.$route.query.usr, this.$route.query.pwd, this.$route.query.tenant);
          }
          this.$utils.log(res);
          if (!res?.access_token) {
            this.$utils.goErr(this.$cfg.errs.NeedPromission);
            throw new Error("抱歉，您没有权限访问此系统！");
          }
          this.$utils.saveToken(res);
          this.$store.dispatch("init");
          await setTimeout(() => {}, 1000);

          this.$utils.log("获取用户");
          const usr = await api.User.get();
          if (this.$route.query.forSys) {
            // 如果需要嵌入第三方系统，参数中含 forSys ，并且此参数保存到 user 上
            usr.forSys = this.$route.query.forSys;
          }
          this.$utils.log(usr);

          this.$store.commit("user", usr);
          this.$utils.log("获取权限");
          const ps = await api.User.queryPermission();
          this.$utils.log(ps);
          if (!ps.length) {
            this.$utils.goErr(this.$cfg.errs.NeedPromission);
            throw new Error("抱歉，您没有权限访问此系统！");
          }
          this.$store.commit("permission", ps);
          this.$store.dispatch("loaders");
        } catch (error) {
          this.$utils.log(error);
          this.showErr("登录失败！");
          return;
        }
      }
      if (!this.token) {
        this.showErr("当前用户尚未登录！");
        return;
      }
      this.$utils.log("登录成功，开始跳转");
      let code = this.$route.query.code;
      if (!code) {
        let hm = await homeApi.SiteMap.query({ srcCode: "home" });
        if (!hm.items.length) {
          this.showErr("首页查询没有配置目标页！");
          return;
        }
        console.log(hm.items)
        code = hm.items[0].tgtCode
      }
      let paras = this.$route.query.paras;
      if (!paras) {
        paras = JSON.stringify({ keyword: this.$route.query.keyword });
      }
      let name = "dynamic"
      if (this.user.forSys) {
        name = "viewer"
      }
      this.$router.replace({ name: name, query: { code: code, paras: paras } });
    },
    methods: {
      showErr(err) {
        this.$message.error(err);
        this.errMsg = err;
      },
    },
  };
</script>
